<template>
  <div class="doctor-page">
    <div class="loading-container" v-if="authorizing">
      <van-loading size="24px">正在授权登录...</van-loading>
    </div>

    <div v-else>
      <div class="user-header">
        <img :src="getAvatarUrl(doctorInfo.avatar)" class="avatar" />
        <div class="user-info">
          <div class="nickname">{{ doctorInfo.doctorName || nickname || '医生' }}</div>
          <div class="bind-status" v-if="isBindDoctor">
            <van-icon name="passed" color="#07c160" /> {{ doctorInfo.department }} - {{ doctorInfo.title }}
          </div>
          <div class="bind-status unbind" v-else @click="goBindIdCard">
            <van-icon name="warning-o" color="#ff976a" /> 点击绑定身份证
          </div>
        </div>
      </div>

      <van-cell-group class="menu-group" v-if="isBindDoctor">
        <van-cell title="今日预约" :value="todayCount + '人'" icon="friends-o" is-link @click="goAppointmentList('today')" />
        <van-cell title="全部预约" :value="totalCount + '人'" icon="orders-o" is-link @click="goAppointmentList('all')" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorIndex',
  data() {
    return {
      authorizing: true,
      isBindDoctor: false,
      doctorInfo: {},
      nickname: '',
      todayCount: 0,
      totalCount: 0,
      defaultAvatar: ''
    }
  },
  created() {
    // 首先检查是否有code参数
    var code = this.$tool.getUrlParamByName('code');
    if (code) {
      // 有code，直接进行授权
      this.handleWechatLogin(code);
    } else {
      // 没有code，检查授权是否过期
      if (this.$tool.isDoctorAuthorized()) {
        var doctorUser = this.$tool.getDoctorUser();
        this.nickname = doctorUser.nickname || '';
        this.isBindDoctor = doctorUser.isBindDoctor || false;
        this.doctorInfo = doctorUser.doctorInfo || {};
        this.authorizing = false;
        if (this.doctorInfo.doctorId) {
          this.loadAppointmentCount();
        }
      } else {
        // 授权过期，检查是否已登录
        if (this.$tool.isDoctorLoggedIn()) {
          // 已登录但授权过期，直接使用本地存储的用户信息
          var doctorUser = this.$tool.getDoctorUser();
          this.nickname = doctorUser.nickname || '';
          this.isBindDoctor = doctorUser.isBindDoctor || false;
          this.doctorInfo = doctorUser.doctorInfo || {};
          this.authorizing = false;
          if (this.doctorInfo.doctorId) {
            this.loadAppointmentCount();
          }
        } else {
          // 未登录，进行微信授权
          this.goWechatAuthorize();
        }
      }
    }
  },
  methods: {
    checkWechatCallback() {
      var code = this.$tool.getUrlParamByName('code');
      if (code) {
        this.handleWechatLogin(code);
      } else {
        this.goWechatAuthorize();
      }
    },
    goWechatAuthorize() {
      var appId = 'wxae49507c8c332234';
      var redirectUri = encodeURIComponent(window.location.origin + window.location.pathname + '#/doctor/index');
      var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId
              + '&redirect_uri=' + redirectUri
              + '&response_type=code&scope=snsapi_userinfo&state=doctor#wechat_redirect';
      window.location.href = url;
    },
    handleWechatLogin(code) {
      this.authorizing = true;
      this.$http.get(this.$Api.doctorWechatAuthorize, {
        params: { code: code }
      }).then(res => {
        this.authorizing = false;
        if (res.data.code === 200) {
          var data = res.data.data;
          // 添加授权时间戳
          data.authorizeTime = new Date().toISOString();
          this.nickname = data.nickname || '';
          this.isBindDoctor = data.isBindDoctor || false;

          this.$tool.setDoctorUser({
            userId: data.userId,
            openid: data.openid,
            isBindDoctor: data.isBindDoctor,
            doctorInfo: data.doctorInfo,
            nickname: data.nickname,
            headimgurl: data.headimgurl,
            authorizeTime: data.authorizeTime
          });

          // 清除URL中的code参数
          this.$tool.clearUrlParams();

          if (data.doctorInfo) {
            this.doctorInfo = data.doctorInfo;
            this.loadAppointmentCount();
          }
        } else {
          // 清除缓存并重新授权
          this.$tool.removeDoctorUser();
          this.$toast.fail(res.data.msg || '授权失败');
          setTimeout(() => {
            this.goWechatAuthorize();
          }, 1000);
        }
      }).catch(() => {
        this.authorizing = false;
        this.$toast.fail('网络错误');
      });
    },
    loadAppointmentCount() {
      if (this.doctorInfo.doctorId) {
        this.$http.get(this.$Api.doctorAppointmentCount, {
          params: { doctorId: this.doctorInfo.doctorId }
        }).then(res => {
          if (res.data.code === 200) {
            this.todayCount = res.data.data.todayCount || 0;
            this.totalCount = res.data.data.totalCount || 0;
          }
        });
      }
    },
    getAvatarUrl(avatar) {
      if (!avatar) return this.defaultAvatar;
      // 检查是否已经是完整URL
      if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
        return avatar;
      }
      // 否则使用当前域名拼接完整URL
      return window.location.origin + avatar;
    },
    goBindIdCard() {
      this.$router.push('/doctor/bindIdCard');
    },
    goAppointmentList(type) {
      this.$router.push('/doctor/appointments?type=' + type);
    }
  }
}
</script>

<style scoped>
.doctor-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.user-header {
  background: linear-gradient(135deg, #3e97c1, #2d7eb0);
  padding: 30px 20px;
  display: flex;
  align-items: center;
}
.avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  margin-right: 15px;
}
.user-info {
  flex: 1;
}
.nickname {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}
.bind-status {
  color: #e8f4ff;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.bind-status .van-icon {
  margin-right: 4px;
}
.bind-status.unbind {
  color: #ffe4b5;
}
.menu-group {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/doctor/index.vue